import "jquery-touchswipe/jquery.touchSwipe";

import "bootstrap";

/* eslint-disable-next-line */
(function ($, ajax_localize) {
    $(document).ready(function () {
        $(window)
            .on("resize", function () {
                breakpointObj.refreshValue();
            })
            .resize(); // Triggers resize listener on page load

        /**
         * Transition Cards - Transition functionality
         */

        $.each($(".transition-card"), function (i, card) {
            let transitionCardButton = $("button.card-button", card);
            let transitionCardID =
                $(transitionCardButton).attr("data-controls");
            let transitionCardTransitionArea = $(".transition-area", card);
            let transitionCardTransitionAreaHeight = $(
                transitionCardTransitionArea
            ).height();
            let transitionCardContentHeight = $(".card-content", card).height();

            // Prepare the transition area for inline ease transition
            $(transitionCardTransitionArea).css(
                "height",
                transitionCardTransitionAreaHeight
            );

            // Transition state styling class
            $(transitionCardButton).on("click", function () {
                $(transitionCardID).toggleClass("transitioned");
            });

            // Height transition functionality
            $(transitionCardButton).on("click", function () {
                if (!$(card).hasClass("transitioned")) {
                    $(transitionCardTransitionArea).css(
                        "height",
                        transitionCardTransitionAreaHeight
                    );
                } else {
                    $(transitionCardTransitionArea).css(
                        "height",
                        transitionCardContentHeight
                    );
                }
            });
        });

        /**
         * Social Slider - Remove read more link for AODA compliance.
         */
        $(".social-slider-block .sbsw-content-text a.sbsw-more").remove();

        // This script will read the current url, if we have a FAQ condition, will open that accordion and scroll to that item
        if ($("body").hasClass("page-faqs")) {
            var urlParams = new URLSearchParams(window.location.search);
            if (urlParams != "") {
                var faqh = urlParams.get("faqh");
                $(".collapse[data-id='" + faqh + "']").collapse("toggle");
                Element.prototype.documentOffsetTop = function () {
                    return (
                        this.offsetTop +
                        (this.offsetParent
                            ? this.offsetParent.documentOffsetTop()
                            : 0)
                    );
                };
                var top =
                    document
                        .querySelector("[data-id='" + faqh + "']")
                        .documentOffsetTop() -
                    window.innerHeight / 2;
                window.scrollTo(0, top);
            }
        }

        /**
         * Modal - YouTube Embed
         */

        $(".video-thumbnail-link").click(function () {
            var videoId = $(this).data("video-id");
            var videoSRC =
                "https://www.youtube.com/embed/" +
                videoId +
                "?enablejsapi=1&version=3&playerapiid=ytplayer";
            $(".embed-responsive[data-video-id=" + videoId + "] iframe").attr(
                "src",
                videoSRC
            );
        });
        $(".btn-close").click(function () {
            var videoId = $(this).data("video-id");
            if (videoId) {
                $(
                    ".embed-responsive[data-video-id=" + videoId + "] iframe"
                ).attr("src", "");
            } else {
                let youTubeIframe = $(this)
                    .closest(".video-modal")
                    .find("iframe");
                let youTubeSource = youTubeIframe.attr("src");
                // re-assign the source to pause the video
                youTubeIframe.attr("src", youTubeSource);
            }
        });

        /**
         * Search - Tab dropdown on mobile
         */
        $("#search-category-dropdown-menu").on("change", function () {
            $("#search-page-filter-tabs")
                .find(".nav-link.active")
                .removeClass("active");
            $("#search-page-filter-tab-content")
                .find(".tab-pane.active")
                .removeClass("active");

            $("#search-page-filter-tabs")
                .find(".nav-link[href='" + $(this).val() + "']")
                .addClass("active");
            $($(this).val()).addClass("show active");
        });

        if (
            window.location.hash !== "" &&
            $("body").hasClass("search-results")
        ) {
            let linkedSearchTab = $("#search-page-filter-tabs").find(
                'a[data-toggle="tab"][href="' + window.location.hash + '"]'
            );

            if (linkedSearchTab.length > 0 && !linkedSearchTab.is(".active")) {
                linkedSearchTab.tab("show");
            }
        }

        // get Cookies
        var getCookie = function (name) {
            var value = "; " + document.cookie;
            var parts = value.split("; " + name + "=");
            if (parts.length == 2) return parts.pop().split(";").shift();
        };

        /**
         * Tabs Block
         */

        // If the url contains a hash, it might be trying to deep link to a specific tab on the page
        // Scroll to and open the tab if it exists
        // Only applies to tabs inside a Tab block
        if (window.location.hash !== "") {
            const linkedTab = $(
                ".tabs-block-block.has-child-page-tab-content"
            ).find(".nav-tabs a[href='" + window.location.hash + "']");

            if (linkedTab.length > 0) {
                let scrollPosition =
                    linkedTab.offset().top -
                    (parseInt($("body > header").outerHeight()) + 30);

                if ($("#wpadminbar").length > 0) {
                    scrollPosition -= $("#wpadminbar").outerHeight();
                }

                $("html, body").animate(
                    {
                        scrollTop: scrollPosition,
                    },
                    1000
                );

                linkedTab.click();
            }
        }

        // Updates browser's address bar by adding click tab's ID and a hash value, to simulate page navigation
        $(".tabs-block-block.has-child-page-tab-content").each(function () {
            $(".nav-tabs [data-toggle='tab']", this).on("click", function () {
                const tabId = $(this).attr("href");
                // console.log(tabId);

                window.history.pushState(null, null, tabId);
            });
        });

        $(".tabs-block-block .mobile-tab-dropdown").on("change", function () {
            let tabList = $(this)
                .closest(".tabs-block-block")
                .find(".nav-tabs");

            let selectedTab = tabList.find(
                'a[data-toggle="tab"][href="' + $(this).val() + '"]'
            );

            if (selectedTab.length > 0 && !selectedTab.is(".active")) {
                selectedTab.tab("show");
            }
        });

        /**
         * Bucket Blocks adding hashs and checking url
         */
        $(".bucket-card button").click(function () {
            window.location.hash = this.dataset.id;
        });

        if (window.location.hash !== "") {
            const buttonBucket = $(
                '.bucket-card button[data-id="' +
                    window.location.hash.substring(1) +
                    '"]'
            );

            if (buttonBucket.length > 0) {
                buttonBucket.click();

                var headerHeight = $("header").height();
                var buttonCardHeight = buttonBucket.parent().height();
                var negativeHeight = headerHeight + buttonCardHeight + 200;

                $("html, body").animate(
                    {
                        scrollTop:
                            $(window.location.hash).offset().top -
                            negativeHeight,
                    },
                    "slow"
                );
            }
        }

        /**
         * Video Block and Video Shortcode Button - Enable pause on modal close
         */
        $(".orange-youtube-video-modal").on("click", function () {
            let hasYouTubeVideo = $(this).find(".youtube-video").length > 0;

            if (hasYouTubeVideo) {
                $(this)
                    .find(".youtube-video")[0]
                    .contentWindow.postMessage(
                        '{"event":"command","func":"' +
                            "pauseVideo" +
                            '","args":""}',
                        "*"
                    );
            }
        });

        /**
         * Carousel - Add active class to first indicator
         */
        $(".carousel-block .carousel-indicators li:first-of-type").addClass(
            "active"
        );

        /**
         * Post Slider - Bootstrap mods
         */
        $(".post-slider .carousel-inner .carousel-item:first-of-type").addClass(
            "active"
        );

        $.each($(".post-slider-block .post-slider"), function (index, slider) {
            var sliderID = "#" + $(slider).attr("id");
            /*
				CC 2.0 License Iatek LLC 2018 - Attribution required
			*/
            $(this).on("slide.bs.carousel", function (e) {
                var $e = $(e.relatedTarget);
                var idx = $e.index();
                var itemsPerSlide = 4;
                var totalItems = $(sliderID + " .carousel-item").length;

                if (idx >= totalItems - (itemsPerSlide - 1)) {
                    var it = itemsPerSlide - (totalItems - idx);
                    for (var i = 0; i < it; i++) {
                        // append slides to end
                        if (e.direction === "left") {
                            $(sliderID + " .carousel-item")
                                .eq(i)
                                .appendTo(sliderID + " .carousel-inner");
                        } else {
                            $(sliderID + " .carousel-item")
                                .eq(0)
                                .appendTo(sliderID + " .carousel-inner");
                        }
                    }
                }
            });
        });

        $(
            ".social-slider .carousel-inner .carousel-item:first-of-type"
        ).addClass("active");

        $.each(
            $(".social-slider-block .social-slider"),
            function (index, slider) {
                var sliderID = "#" + $(slider).attr("id");
                /*
				CC 2.0 License Iatek LLC 2018 - Attribution required
			*/
                $(this).on("slide.bs.carousel", function (e) {
                    var $eS = $(e.relatedTarget);
                    var idxS = $eS.index();
                    var itemsPerSlideS = 4;
                    var totalItemsS = $(
                        sliderID + " .carousel-item.social"
                    ).length;

                    // console.log('total: '+totalItemsS);

                    if (idxS >= 4) {
                        var it = itemsPerSlideS - (totalItemsS - idxS);
                        for (var i = 0; i < it; i++) {
                            // append slides to end
                            if (e.direction === "left") {
                                $(sliderID + " .carousel-item.social")
                                    .eq(i)
                                    .appendTo(
                                        sliderID + " .carousel-inner.social"
                                    );
                            } else {
                                $(sliderID + " .carousel-item.social")
                                    .eq(0)
                                    .appendTo(
                                        sliderID + " .carousel-inner.social"
                                    );
                            }
                        }
                    }
                });
            }
        );

        /* Initialize Carousel */
        $(".carousel.ocb").carousel({
            pause: true,
        });

        /* Play trigger */
        $(".carousel-control-cycle-toggle").on("click", function () {
            var state = $(this).hasClass("oc-pause") ? "cycle" : "pause";

            var carouselId = $(this).closest(".carousel").attr("id");

            $("#" + carouselId).carousel(state);

            $(this).toggleClass("oc-pause");
        });

        /**
         * Video - play video when modal opened
         */
        $(".video-block a.video-thumbnail-link").on("click", function () {
            $(this).parent().find("video").trigger("play");
        });

        /**
         * Testimonial - play/pause functionality
         */
        /*$( '.testimonial-block a.carousel-control-pause' ).on( 'click', function(){
			var carousel = $( this ).parent().parent().attr( 'id' );

			if( $( this ).hasClass( 'paused' ) ) {
				$( '#' + carousel ).carousel('cycle');
				$( this ).toggleClass( 'paused' );

			} else {
				$( '#' + carousel ).carousel('pause');
				$( this ).toggleClass( 'paused' );
			}
		});*/

        /**
         * Testimonial - play/pause functionality
         */
        $(".team-member-block .team-member .card-content-expand-btn").on(
            "click",
            function () {
                $(this).animate({ opacity: 0, height: 0 }, 200, function () {
                    $(this).hide();
                });
            }
        );

        // create function, it expects 2 values.
        /* eslint-disable-next-line */
        function insertAfter(newElement, targetElement) {
            // target is what you want it to go after. Look for this elements parent.
            var parent = targetElement.parent();
            //console.log(parent);

            // if the parents lastchild is the targetElement...
            if (parent.lastChild === targetElement) {
                // add the newElement after the target element.
                parent.appendChild(newElement);
            } else {
                // else the target has siblings, insert the new element between the target and it's next sibling.
                parent.insertBefore(newElement, targetElement.nextSibling);
            }
        }

        // console.log('here');
        //need to change this to a dom listener
        setTimeout(function () {
            if ($("#sb_instagram").length) {
                var index = 1;
                $(".sbi_item").each(function () {
                    var social_container = $(".social-container");
                    if (index === 2) {
                        $(this).after(social_container);
                        social_container.removeClass("hidden-unless-required");
                    }

                    index++;
                });
            }
        }, 1000);

        /**
         * Alert System
         */
        $(
            "#alert-carousel .carousel-inner .carousel-item:first-of-type"
        ).addClass("active");
        // Cookies
        function alertSetCookie(exdays) {
            var d = new Date();

            if ($("#alert-system").hasClass("stylish-alert")) {
                d.setTime(d.getTime() + 15 * 60000);
            } else {
                d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
            }

            var expires = "expires=" + d.toUTCString();
            document.cookie =
                "hideAlerts" + "=" + true + ";" + expires + ";path=/";
        }

        $("#alert-system .close").click(function () {
            alertSetCookie(7); // 7 days
            $("body").addClass("alert-hidden");
        });

        var cookieVal = getCookie("hideAlerts");

        if (cookieVal) {
            $("#alert-system").hide();
            $("body").addClass("alert-hidden");
        } else {
            $("#alert-system").show();
        }

        /**
         * Form - Add class to li.gfield to identify containing input
         */
        $(".ginput_complex").parent().addClass("gfield_complex");

        /**
         * Spotlight Carousel
         */
        $(".spotlight-carousel-block .spotlight-text-carousel")
            .on("slide.bs.carousel", function (evt) {
                let spotlightImageCarousel = $(this)
                    .closest(".spotlight-carousel-block")
                    .find(".spotlight-image-carousel");

                let cycleCommand = evt.direction === "left" ? "next" : "prev";

                spotlightImageCarousel.carousel(cycleCommand);
            })
            .find(".carousel-control-cycle-toggle")
            .on("click", function () {
                let spotlightImageCarousel = $(this)
                    .closest(".spotlight-carousel-block")
                    .find(".spotlight-image-carousel");

                let carouselCommandKeyword = $(this).hasClass("oc-pause")
                    ? "pause"
                    : "cycle";

                spotlightImageCarousel.carousel(carouselCommandKeyword);
            });

        /**
         * Features Carousel
         */

        // Ensure that each slide is the same height in each features block carousel
        equalCarouselItemHeights(
            ".features-carousel-block .tab-pane.active .features-carousel"
        );

        let resizeThrottled = false;

        $(window).on("resize", function () {
            if (!resizeThrottled) {
                equalCarouselItemHeights(
                    ".features-carousel-block .tab-pane.active .features-carousel:visible"
                );

                resizeThrottled = true;

                setTimeout(function () {
                    resizeThrottled = false;
                }, 100);
            }
        });

        /* eslint-disable-next-line */
        $(document).on("breakpoint:changed", function (evt, newBreakpointName) {
            //console.log(evt);
            //console.log(newBreakpointName);

            $.each($(".features-carousel-block"), function (index, block) {
                toggleFeaturesCarouselControlVisibility($(block));
            });
        });

        $(
            '.features-carousel-block .feature-types-tab-list a[data-toggle="tab"]'
        ).on("shown.bs.tab", function (evt) {
            let shownTabPaneId = $(evt.target).attr("href");

            let shownCarouselId =
                "#" + $(shownTabPaneId).find(".features-carousel").attr("id");

            let numShownCarouselSlides =
                $(shownCarouselId).find(".carousel-item").length;

            let currBreakpoint = breakpointObj.value;

            toggleFeaturesCarouselControlVisibility(
                $(this).closest(".features-carousel-block")
            );

            if (
                numShownCarouselSlides >
                itemsPerSlideByBreakpoint[currBreakpoint]
            ) {
                $(evt.target)
                    .closest(".tab-carousel-navigation-container")
                    .find(".carousel-controls a[data-slide]")
                    .attr("href", shownCarouselId);
            }

            equalCarouselItemHeights(
                $(this)
                    .closest(".features-carousel-block")
                    .find(".tab-pane.active .features-carousel:visible")
            );
        });

        $.each($(".features-carousel-block"), function (index, block) {
            toggleFeaturesCarouselControlVisibility($(block));

            $.each(
                $(block).find(".features-carousel"),
                function (sliderIndex, slider) {
                    var sliderID = "#" + $(slider).attr("id");

                    let carouselControls = $(this)
                        .closest(".orange-block")
                        .find(".carousel-controls");

                    let leftControlBtn = carouselControls.find(
                        '[data-slide="prev"]'
                    );
                    let rightControlBtn = carouselControls.find(
                        '[data-slide="next"]'
                    );

                    if (!$(this).is("[data-ride]")) {
                        $(this).carousel("pause");
                    }

                    // Code that allows from continuous cycle of carousel.
                    $(this)
                        .on("slide.bs.carousel", function (evt) {
                            if (
                                $(window).width() <
                                parseInt($(":root").css("--breakpoint-md"))
                            ) {
                                return;
                            }

                            let newActiveItem = $(evt.relatedTarget);

                            let newActiveItemIndex = evt.to;

                            if (evt.direction === "left") {
                                if (newActiveItemIndex >= 2) {
                                    $(sliderID)
                                        .find(".carousel-item")
                                        .eq(newActiveItemIndex - 2)
                                        .addClass("carousel-item-left");
                                }

                                newActiveItem
                                    .prev()
                                    .addClass("carousel-item-outside");
                            } else if (evt.direction === "right") {
                                if (newActiveItemIndex >= 1) {
                                    let newPrevCarouselItem =
                                        newActiveItem.prev();

                                    newPrevCarouselItem
                                        .addClass(
                                            "carousel-item-outside carousel-item-prev-prev"
                                        )
                                        // This reflows the element, meaning the browser will calculate the styles and layout of the element
                                        // Any classes added after this will then trigger any transitions associated with the class
                                        // This avoids any delays caused by the "wait a tick" method
                                        .outerHeight();

                                    newPrevCarouselItem.addClass(
                                        "carousel-item-right"
                                    );
                                }
                            }
                        })
                        .on("slid.bs.carousel", function (evt) {
                            if (
                                $(window).width() <
                                parseInt($(":root").css("--breakpoint-md"))
                            ) {
                                return;
                            }

                            let itemsPerSlide =
                                itemsPerSlideByBreakpoint[breakpointObj.value];

                            let currActiveItem = $(evt.relatedTarget);

                            let currItemIndex = evt.to;

                            let totalItems =
                                $(sliderID).find(".carousel-item").length;

                            if (evt.direction === "left") {
                                if (leftControlBtn.is("[disabled]")) {
                                    leftControlBtn.attr("disabled", null);
                                }

                                if (currItemIndex >= 2) {
                                    $(sliderID)
                                        .find(".carousel-item")
                                        .eq(currItemIndex - 2)
                                        .removeClass(
                                            "carousel-item-outside carousel-item-left"
                                        );
                                }

                                // When the last item aligns with the right edge of the carousel container
                                if (
                                    currItemIndex >=
                                    totalItems - itemsPerSlide
                                ) {
                                    rightControlBtn.attr(
                                        "disabled",
                                        "disabled"
                                    );
                                }
                            } else if (evt.direction === "right") {
                                if (rightControlBtn.is("[disabled]")) {
                                    rightControlBtn.attr("disabled", null);
                                }

                                // When the first item aligns with the left edge of the carousel container
                                if (currItemIndex === 0) {
                                    leftControlBtn.attr("disabled", "disabled");
                                }

                                currActiveItem.removeClass(
                                    "carousel-item-outside"
                                );

                                $(sliderID)
                                    .find(
                                        ".carousel-item.carousel-item-prev-prev"
                                    )
                                    .removeClass(
                                        "carousel-item-prev-prev carousel-item-right"
                                    );
                            }
                        });
                }
            );

            $(block)
                .find(".feature-types-tab-mobile-dropdown")
                .on("change", function () {
                    let tabList = $(this)
                        .closest(".tab-carousel-navigation-container")
                        .find(".feature-types-tab-list");

                    let selectedSearchTab = tabList.find(
                        'a[data-toggle="tab"][href="' + $(this).val() + '"]'
                    );

                    if (
                        selectedSearchTab.length > 0 &&
                        !selectedSearchTab.is(".active")
                    ) {
                        selectedSearchTab.tab("show");
                    }
                });
        });

        /**
         * Timeline
         */
        $.each($(".timeline-block"), function (index, timelineBlock) {
            let listItemHolder = $(timelineBlock).find(".timeline-entry-list");

            let listItemsLoader = $(".timeline-items-loader", listItemHolder);

            let loadMoreBtn = $(timelineBlock).find(".btn-timeline-load-more");

            // Hide the button if there aren't any more posts to load
            if (listItemsLoader.length === 0) {
                loadMoreBtn.hide();
            }

            let loadMoreXHR = null;

            loadMoreBtn.on("click", function (evt) {
                evt.preventDefault();

                listItemsLoader = $(".timeline-items-loader", listItemHolder);

                if (loadMoreBtn.is(".loading") && loadMoreXHR != null) {
                    loadMoreXHR.abort();
                }

                // Save the button's text so we can restore it when removing the loading state
                var origButtonText = loadMoreBtn.html();

                loadMoreBtn
                    .attr("disabled", true)
                    .addClass("loading")
                    .text("Loading...");

                var action = "get_timeline_entries";

                let requestData = listItemsLoader.data();

                loadMoreXHR = $.post(
                    ajax_localize.ajax_url,
                    {
                        action: action,
                        data: $.param(requestData),
                    },
                    function (data) {
                        // Remove the existing list item loader since a new one will be included in the response
                        listItemsLoader.remove();

                        // If new faq items were returned
                        if (data) {
                            loadMoreBtn
                                .attr("disabled", false)
                                .removeClass("loading")
                                .html(origButtonText);

                            loadMoreXHR = null;

                            var newListItems = $($.parseHTML(data));

                            newListItems
                                .filter(":not(.list-items-loader)")
                                .addClass("fade");

                            listItemHolder.append(newListItems);

                            // Wait a split second before adding class to fade in new faqs
                            setTimeout(function () {
                                newListItems.filter(".fade").addClass("show");
                            }, 100);

                            let newListItemLoader = $(
                                ".timeline-items-loader",
                                listItemHolder
                            );

                            if (newListItemLoader.length === 0) {
                                loadMoreBtn.hide();
                            } else if (loadMoreBtn.is(":hidden")) {
                                loadMoreBtn.show();
                            }
                        } else {
                            loadMoreBtn.fadeOut(400);
                        }
                    }
                );
            });
        });

        // Check if the Project Logo is visible, if yes, hide the h1 title
        if ($(".navbar-brand img").is(":visible")) {
            $(".navbar-brand h1").addClass("logo-visible");
        }
    });

    let breakpointObj = {};

    breakpointObj.refreshValue = function () {
        if (typeof this.value === "undefined") {
            this.value = "";
        }

        let newBreakpointName = $(":root")
            .css("--curr-breakpoint")
            .trim()
            .replace(/"/g, "");

        let valueChanged = true;

        if (this.value === newBreakpointName) {
            valueChanged = false;
        }

        this.value = newBreakpointName;

        if (valueChanged) {
            $("body").trigger("breakpoint:changed", [newBreakpointName]);
        }
    };

    breakpointObj.minWidthInt = function () {
        if (typeof this.value === "undefined" || this.value === "") {
            return 0;
        }

        return parseInt($(":root").css("--breakpoint-" + this.value));
    };

    let itemsPerSlideByBreakpoint = {
        xxs: 1,
        xs: 1,
        sm: 1,
        md: 2,
        lg: 3,
        xl: 3,
        xxl: 3,
    };

    let toggleFeaturesCarouselControlVisibility = function (
        featuresCarouselBlock
    ) {
        let currBreakpoint = breakpointObj.value;

        let activeCarousel = featuresCarouselBlock.find(
            ".tab-pane.active .features-carousel"
        );

        let totalCarouselItems = activeCarousel.find(".carousel-item").length;

        if (totalCarouselItems > itemsPerSlideByBreakpoint[currBreakpoint]) {
            featuresCarouselBlock
                .find(".carousel-controls")
                .css("visibility", "");

            featuresCarouselBlock
                .find(".carousel-controls > a[data-slide]")
                .attr("disabled", null);

            if (
                activeCarousel
                    .find(".carousel-item:first-child")
                    .hasClass("active") &&
                $(window).width() >= parseInt($(":root").css("--breakpoint-md"))
            ) {
                // Since control button is an anchor, updating disabled property basically does nothing
                featuresCarouselBlock
                    .find('.carousel-controls > [data-slide="prev"]')
                    .attr("disabled", "disabled");
            }
        } else {
            featuresCarouselBlock
                .find(".carousel-controls")
                .css("visibility", "hidden");
        }
    };

    let equalCarouselItemHeights = function (carouselSelector) {
        $(carouselSelector).each(function () {
            var items = $(".carousel-item", this);
            let maxHeight = 0;

            let currActiveSlide = $(".carousel-item.active", this);

            // Show all slides
            $.each(items, function (i, slide) {
                $(this).css("height", "");

                $(slide).addClass("active");
            });

            // Get the height of the tallest caption and save it
            $.each(items, function () {
                let itemHeight = $(this).outerHeight();

                if (itemHeight > maxHeight) {
                    maxHeight = itemHeight;
                }
            });

            // Apply the max height to all captions
            $.each(items, function () {
                $(this)
                    .css("height", maxHeight)
                    // Remove .active from all slides
                    .removeClass("active");
            });

            // Add the active class back to the active slide
            currActiveSlide.addClass("active");
        });
    };

    /* eslint-disable-next-line */
})(jQuery, ajax_localize);
